import { render, staticRenderFns } from "./DetailPerpanjangan.vue?vue&type=template&id=24eec74d&"
import script from "./DetailPerpanjangan.vue?vue&type=script&lang=js&"
export * from "./DetailPerpanjangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports